export enum LimitOrderStatus {
  WATCH = 'WATCH',
  FIRED = 'FIRED',
  CONSUMED = 'CONSUMED',
  CANCELED = 'CANCELED',
  FAILED = 'FAILED',
}

export enum ExecutionType {
  GRID = 'GRID',
  LIMIT = 'LIMIT',
  TIME_DISTANCE = 'TIME_DISTANCE',
}

export enum TriggerType {
  Overline = 'OVERLINE',
  StopLimit = 'STOP_LIMIT',
}
